/**
* @license Apache-2.0
*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

var consts = {
	'CR': 0,
	'LF': 1,
	'Control': 2,
	'Extend': 3,
	'RegionalIndicator': 4,
	'SpacingMark': 5,
	'L': 6,
	'V': 7,
	'T': 8,
	'LV': 9,
	'LVT': 10,
	'Other': 11,
	'Prepend': 12,
	'ZWJ': 13,
	'NotBreak': 0,
	'BreakStart': 1,
	'Break': 2,
	'BreakLastRegional': 3,
	'BreakPenultimateRegional': 4,
	'ExtendedPictographic': 101
};


// EXPORTS //

export default consts;
